import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedOutUser } from './mockFullLoggedOutUser';

export const mockFullLoggedOutUserLongBio: MockResponseConfig = {
  ...mockFullLoggedOutUser,
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          bio: "<p>Hi I'm an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer.</p>",
          company: 'Nike',
          aaid: '62587f99fdb60b0069294184',
          linkedinUrl: 'linkedin.com/colbystauss',
          accountInternalId: '541b9286-8563-4825-aae8-43e7e90fb493',
          location: 'Kansas, USA',
          products: 'analytics,halp,hipchat',
          role: 'CEO',
          internalId: 'c34de571-576f-45e6-8c02-0917609af889',
          username: 'loggedoutlongbio',
          websiteUrl: 'colbystauss.net',
          xUrl: 'x.com/colby',
          youtubeUrl: 'youtube.com/colby',
          isPrivate: false,
          isPersonalView: false,
          isLinkedView: false,
        },
        atlassianProducts: {
          __typename: 'UnifiedAtlassianProductConnection',
          edges: [],
          totalCount: 0,
        },
      },
    },
  }),
};
